import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import ErrorPage from "./components/ErrorPage.jsx";
import Home from "./pages/Home.jsx";
import About from "./pages/About/About.jsx";
import Login from "./pages/Login/Login.jsx";
import Profile from "./pages/Profile/Profile.jsx";
import NotFound from "./pages/NotFound.jsx";
import { Cart } from "./pages/Cart/Cart.jsx";
import CartBlocker from "./components/cart-blocker/cart-blocker.jsx";
import ProductDetail from "./pages/product-detail/product-detail.jsx";
import Termos from "./pages/TermsOfUse/TermsOfUse.jsx";
import CookiesPolicyPage from "./pages/CookiesPolicyPage/CookiesPolicyPage.jsx";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage/PrivacyPolicyPage.jsx";
import Links from "./pages/Linktree/Links.jsx";
import Help from "./pages/Help/Help.jsx";
import App from "./App";
import Layout from "./components/Layout/Layout.jsx";
import { Outlet } from "react-router-dom";
import FollowupSection from "./pages/Profile/FollowupSection.jsx";
import MeusPedidos from "./pages/Profile/Meus-Pedidos.jsx";
import AccordionTransition from "./pages/Help/Help.jsx";
import Produtos from "./pages/Produtos.jsx";
import CategoriaProdutos from "./pages/CategoriaProdutos.jsx";
import DepartamentoProdutos from "./pages/DepartmentProdutos.jsx";
import Checkout from "./pages/Checkout/Checkout.cart.jsx";
import EmailRecovery from "./pages/Email/EmailRecovery.jsx";
import EmailConfirm from "./pages/ConfirmarEmail.jsx";
import SearchResults from "./pages/SearchResults.jsx";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <App>
          <Outlet />
        </App>
      }
      errorElement={<ErrorPage />}>
      <Route
        path="/"
        element={
          <Layout>
            <Home />
          </Layout>
        }
      />
      <Route
        path="sobre"
        element={
          <Layout>
            <About />
          </Layout>
        }
      />
      <Route
        path="/busca"
        element={
          <Layout>
            <SearchResults />
          </Layout>
        }
      />
      <Route path="login" element={<Login />} />
      <Route path="confirmar-email" element={<EmailConfirm />} />
      <Route path="Links" element={<Links />} />
      <Route path="emailrec" element={<EmailRecovery />} />
      <Route
        path="minha-conta"
        element={
          <Layout>
            <Profile />
          </Layout>
        }
      />
      <Route
        path="Ajuda"
        element={
          <Layout>
            <Help />
          </Layout>
        }
      />
      <Route
        path="Cart"
        element={
          <Layout>
            <Cart />
          </Layout>
        }
      />
      <Route path="cartblocker" element={<CartBlocker />} />
      <Route
        path="produto/:id"
        element={
          <Layout>
            <ProductDetail />
          </Layout>
        }
      />
      <Route path="*" element={<NotFound />} />
      <Route
        path="Termos-de-uso"
        element={
          <Layout>
            <Termos />
          </Layout>
        }
      />
      <Route
        path="Politicas-de-privacidade"
        element={
          <Layout>
            <PrivacyPolicyPage />
          </Layout>
        }
      />
      <Route
        path="Cookies-e-politicas"
        element={
          <Layout>
            <CookiesPolicyPage />
          </Layout>
        }
      />
      <Route path="/FollowupSection" element={<FollowupSection />} />
      <Route path="/Meus-Pedidos" element={<MeusPedidos />} />
      <Route
        path="/Help"
        element={
          <Layout>
            <AccordionTransition />
          </Layout>
        }
      />
      <Route
        path="/produtos"
        element={
          <Layout>
            <Produtos />
          </Layout>
        }
      />
      <Route
        path="/categoria/:categoria"
        element={
          <Layout>
            <CategoriaProdutos />
          </Layout>
        }
      />
      <Route
        path="/departamento/:departamento"
        element={
          <Layout>
            <DepartamentoProdutos />
          </Layout>
        }
      />
      <Route
        path="teste"
        element={
          <Layout>
            <Checkout />
          </Layout>
        }
      />
    </Route>
  )
);

export default router;
